import viewTransitionNavUtility from "@Utils/viewTransitionNavUtility";
import { stripPropertyImageViewTransitionNames } from "@Utils/pdpViewTransitionNav";
import { isNewNativeAppShell, parseAppShell } from "constants/appShell";
import { sendWebViewEvent } from "@Utils/webviewEvents";
import { WEB_VIEW_APP_EVENTS } from "@Utils/webApputils/analyticEvents";

/**
 * App header / form back.
 * New native shells (iOS + Android) → `NAVIGATE_BACK` (native walks its own WebView history
 * or dismisses). RN / other hosts → `history.goBack()` with release-style view transition.
 */
export const webAppBackHandler = (history: any) => {
  const shell = typeof window !== "undefined" ? parseAppShell(window.appShell) : "";

  if (isNewNativeAppShell(shell)) {
    sendWebViewEvent(WEB_VIEW_APP_EVENTS.NAVIGATE_BACK, {});
    return;
  }

  stripPropertyImageViewTransitionNames();
  document.body.classList.add("pdp-back-vt");

  requestAnimationFrame(() => {
    viewTransitionNavUtility(() => {
      history.goBack();
    }, "left-to-right");
  });
};
export default webAppBackHandler;
